/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `MobileHeader` for the Caintra Connect frontend.
 * @module components/MobileHeader
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import { useTranslation } from "react-i18next";
import styles from "../styles/MobileHeader.module.css";
import LanguageSelector from "./LanguageSelector";
import NotificationBell from "./NotificationBell";

import { ReactComponent as BurgerIcon } from "../assets/icons/SideMenu/BurgerIcon.svg";
import { ReactComponent as CaintraMobileIcon } from "../assets/icons/CaintraMobileIcon.svg";

const MobileHeader = ({ onMenuToggle, isMenuOpen }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.mobileHeader}>
      <div className={styles.leftSection}>
        <button
          className={`${styles.burgerButton} ${
            isMenuOpen ? styles.active : ""
          }`}
          onClick={onMenuToggle}
          aria-label={t("common.toggleMenu")}
        >
          <BurgerIcon />
        </button>
        <CaintraMobileIcon className={styles.caintraIcon} />
      </div>

      <div className={styles.rightSection}>
        <NotificationBell />
        <LanguageSelector />
      </div>
    </div>
  );
};

export default MobileHeader;
